module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/Direction/components/Building/images/artillery-battalion-lvl1-100.5812d27a.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/Direction/components/Building/images/artillery-battalion-lvl1-100.png
// module id = 3279
// module chunks = 11